import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "collage__products-info-container" }
const _hoisted_2 = { class: "q-row q-px-5 q-mb-2 q-bg-white get-the-look__gtl-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "show-products__button-icon q-position-relative" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import {ref, PropType, computed} from 'vue'
import GetTheLook from '@/components/GetTheLook/GetTheLook.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CollagesInfoComponent',
  props: {
  products: [],
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {

const props = __props;




const showOnHover = ref(false);
// co

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showOnHover.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["collage__products-info q-position-absolute q-row", {active:showOnHover.value}])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
              return (_openBlock(), _createBlock(GetTheLook, {
                key: product.id,
                product: product,
                "use-as-separate": __props.useAsSeparate
              }, null, 8, ["product", "use-as-separate"]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["show-products__button q-position-absolute", {active: showOnHover.value}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showOnHover.value = !showOnHover.value))
    }, _hoisted_4, 2)
  ]))
}
}

})